<template>
  <div
    class="cta-button type-button"
    :theme="_theme"
    :hovering="isHovering ? true : null"
  >
    <slot />
    <IconArrow
      class="icon"
      v-if="showArrow"
    />
  </div>
</template>

<script setup lang="ts">
import IconArrow from "@/icons/arrow-forward-20.svg?component"
const props = defineProps({
  theme: {},
  hovering: {},
  showArrow: {
    default: true,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

// *********************************************
// HOVERING
// *********************************************

const _hovering = useElementHover(refRoot)
const isHovering = computed(() => {
  if (props.hovering != undefined) return props.hovering
  return _hovering.value
})

// *********************************************
// THEME
// *********************************************

const injectedTheme = inject("theme")

const _theme = computed(() => {
  if (props.theme) {
    return props.theme
  }
  if (injectedTheme) {
    return injectedTheme
  }
  return "white"
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.cta-button {
  padding-inline: 1.4rem;
  border-radius: 0.6rem;
  height: 3.6rem;
  @include flex(row, center, center);
  margin-block: $p4;
  background: $cl-light;
  color: $cl-black;
  transition: all 0.2s ease;
}

.icon {
  width: 2rem;
  height: 2rem;
  margin-left: $p1;
}

.cta-button[hovering] {
  background: white;
}

.cta-button[active] {
  background: rgba($cl-light, 0.8);
}

.cta-button[disabled] {
  background: white;
  opacity: 0.3;
}
</style>
